module.exports = __webpack_public_path__ + "static/media/avicom-team.b959c972.png";